import { Reveal, Kicker } from "./motion";

const stories = [
  {
    quote:
      "Placeholder pull quote. A line from a chef or owner about calmer services and evenings that end on time.",
    name: "Placeholder venue",
    detail: "Gastropub, South West England",
  },
  {
    quote:
      "Placeholder pull quote. A line about seeing the numbers during service and making one decision that saved the night.",
    name: "Placeholder venue",
    detail: "Independent group, London",
  },
];

export default function CustomerStories() {
  return (
    <section
      data-testid="customer-stories"
      className="px-6 md:px-12 py-28 md:py-40 border-t border-verlo/10"
    >
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <Kicker>From the floor</Kicker>
          <h2 className="mt-6 font-display font-light text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.1] text-verlo max-w-3xl">
            Stories from the people running it
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-24 space-y-24 md:space-y-32">
          {stories.map((s, i) => (
            <Reveal key={i}>
              <div className="grid md:grid-cols-12 gap-8 md:gap-16 items-center">
                <div
                  className={`md:col-span-5 ${i % 2 === 1 ? "md:order-2" : ""}`}
                >
                  <div className="relative aspect-[4/5] bg-[rgba(32,27,95,0.06)] border border-verlo/15 flex items-center justify-center">
                    <span className="text-xs tracking-[0.2em] uppercase text-verlo/40">
                      Placeholder, content pending
                    </span>
                  </div>
                </div>
                <div className="md:col-span-6">
                  <blockquote className="font-display font-light text-2xl md:text-4xl leading-[1.35] text-verlo">
                    {s.quote}
                  </blockquote>
                  <div className="mt-8 flex items-center gap-4">
                    <span className="h-px w-12 bg-brass" />
                    <div>
                      <p className="text-verlo font-medium">{s.name}</p>
                      <p className="text-sm text-verlo/50">{s.detail}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
